// export Spain-specific contacts configuration for stage
export { spainContactsConfig as default } from "@/config/countries/spain/contacts.config";
